// vue
import { ref } from '@vue/composition-api';
// import { useStore } from 'vuex';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { RemoteLoginMapping } from '@/vue3/api/models';

export const useRemoteLoginMappingService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const getRemoteLoginMappingByAccountId = async (
        accountId: number,
    ): Promise<RemoteLoginMapping> => {
        const res = await axios.get(`${apiUrl}/passthrough-token/${accountId}`);
        return res.data;
    };

    const getRemoteLoginMapping = async (): Promise<RemoteLoginMapping> => {
        const res = await axios.get(`${apiUrl}/passthrough-token`);
        return res.data;
    };

    const upsertRemoteLoginMapping = async (
        remoteLoginMapping: RemoteLoginMapping,
    ): Promise<RemoteLoginMapping> => {
        const res = await axios.put(
            `${apiUrl}/passthrough-token`,
            remoteLoginMapping,
        );
        return res.data;
    };

    return {
        getRemoteLoginMappingByAccountId,
        getRemoteLoginMapping,
        upsertRemoteLoginMapping,
    };
};
